// extracted by mini-css-extract-plugin
export var bgImage = "Farms-module--bgImage--cab7e";
export var blockDescription = "Farms-module--blockDescription--9850d";
export var content = "Farms-module--content--9ae04";
export var farms = "Farms-module--farms--cbbe3";
export var farmsBridgesStake = "Farms-module--farmsBridgesStake--5dcde";
export var farms_wrapper = "Farms-module--farms_wrapper--78a6b";
export var wrapper = "Farms-module--wrapper--46e04";